<template>
  <h1>fritid</h1>
</template>

<script>
export default {

}
</script>

<style>

</style>